/**
 * Pure helpers for routine (profile) previous-vaccination flow.
 */

export const getRoutineBeneficiaryType = (row, explicitType) => {
  if (explicitType) return explicitType;
  if (row?.lmc_date || row?.is_pregnant_woman) return 'PW';
  return 'CHILD';
};

export const buildRoutineBeneficiaryData = (row, options = {}) => ({
  beneficiary_id: row?.beneficiary_id,
  beneficiary_reference_id: row?.beneficiary_reference_id,
  ben_name: row?.ben_name,
  dob: row?.dob,
  beneficiary_gender: row?.beneficiary_gender,
  ben_mobile_number: row?.ben_mobile_number,
  photo_id_type: row?.photo_id_type || row?.beneficiary_id_type_name,
  photo_id_number: row?.photo_id_number,
  session_site_id: row?.session_site_id || options.sessionSiteId,
  lmc_date: row?.lmc_date,
  edd_date: row?.edd_date,
});
